var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "send-btn-container-" + _vm.localAlign }, [
    _c(
      "button",
      {
        staticClass: "send-btn",
        attrs: { id: "container" },
        on: { click: _vm.sendForm },
      },
      [
        _c("div", { staticClass: "btn-content" }, [
          _c("span", { staticClass: "btn-text" }, [
            _vm._v(_vm._s(_vm.displayLabel)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btn-icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              },
              [
                _c("line", {
                  attrs: { x1: "22", y1: "2", x2: "11", y2: "13" },
                }),
                _vm._v(" "),
                _c("polygon", { attrs: { points: "22,2 15,22 11,13 2,9" } }),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }